import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import * as location from '@adjust/dashboard-core/lib/utils/location';
import { getCurrentUser as getCurrentUserApi } from '@adjust/dashboard-core/api/account';
import { getErrorMessageFromResponse } from '@adjust/dashboard-core/lib/errorMessage/errorMessage';
import { getTimezones } from '@api/account';
import {
  getUserDetails as getUserDetailsApi,
  updateUser as updateUserApi,
  deleteUser as deleteUserApi,
} from '@api/user';
import { getCurrentUser, setTimezones, setUser } from '@redux/ducks/global';

import {
  DELETE_USER,
  USER_DETAILS_FETCH_STARTED,
  UPDATE_USER,
  fetchUserDetailsSucceeded,
  updateUserFailed,
  updateUserSucceeded,
  deleteUserFailed,
  deleteUserSucceeded,
  getUserDetails,
} from '@redux/ducks/userDetails/userDetails';
import { deleteUser, editUser } from '@redux/ducks/users';

// Watchers

export function* watchFetchData() {
  yield takeLatest(USER_DETAILS_FETCH_STARTED, fetchUserDetailsTask);
}

export function* watchUpdateUser() {
  yield takeLatest(UPDATE_USER, updateUserTask);
}

export function* watchDeleteUser() {
  yield takeLatest(DELETE_USER, deleteUserTask);
}

// Workers

export function* fetchUserDetailsTask({ payload }) {
  try {
    const [currentUserResp, timezones] = yield all([
      call(getCurrentUserApi, { forceUpdate: true }),
      call(getTimezones),
    ]);

    yield put(setUser({ ...currentUserResp }));
    yield put(setTimezones(timezones));

    const userResp = payload.userId
      ? yield call(getUserDetailsApi, {
          id: payload.userId,
          accountId: currentUserResp.current_account_id,
        })
      : currentUserResp;

    yield put(fetchUserDetailsSucceeded(userResp));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
}

export function* updateUserTask({ payload }) {
  try {
    const currentUser = yield select(getCurrentUser);
    const user = yield select(getUserDetails);

    const result = yield call(updateUserApi, currentUser.current_account_id, user.id, payload);

    const isCurrentUserEdited = currentUser.id === result.id;
    const isLangChanged = currentUser.language !== result.language;

    if (isCurrentUserEdited && isLangChanged) {
      yield call(location.reload);
    } else {
      if (isCurrentUserEdited) {
        yield put(setUser(result));
      } else {
        yield put(editUser(result));
      }
      yield put(updateUserSucceeded());
    }
  } catch (err) {
    yield put(updateUserFailed(getErrorMessageFromResponse(err.data)));
  }
}

export function* deleteUserTask() {
  try {
    const currentUser = yield select(getCurrentUser);
    const user = yield select(getUserDetails);

    yield call(deleteUserApi, currentUser.current_account_id, user.id);

    yield put(deleteUser(user.id));
    yield put(deleteUserSucceeded());
  } catch (err) {
    yield put(deleteUserFailed(getErrorMessageFromResponse(err.data)));
  }
}

// Saga

export default function* userDetailsSaga() {
  yield all([watchFetchData(), watchUpdateUser(), watchDeleteUser()]);
}
